import { render, staticRenderFns } from "./base-layout.vue?vue&type=template&id=482a321c"
import script from "./base-layout.vue?vue&type=script&lang=js"
export * from "./base-layout.vue?vue&type=script&lang=js"
import style0 from "./base-layout.vue?vue&type=style&index=0&id=482a321c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports